import React from "react";

export default function Server() {
  return (
    <svg
      width="480"
      height="480"
      viewBox="0 0 480 480"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Server">
        <g id="Group">
          <g id="Group_2">
            <path
              id="Vector"
              d="M152 408.009H136V424.009H152V408.009Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_3">
          <g id="Group_4">
            <path
              id="Vector_2"
              d="M184 408.009H168V424.009H184V408.009Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_5">
          <g id="Group_6">
            <path
              id="Vector_3"
              d="M152 312.009H136V328.009H152V312.009Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_7">
          <g id="Group_8">
            <path
              id="Vector_4"
              d="M184 312.009H168V328.009H184V312.009Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_9">
          <g id="Group_10">
            <path
              id="Vector_5"
              d="M376 120.009C371.371 120.011 366.748 120.321 362.16 120.937C340.602 49.0186 264.824 8.19356 192.906 29.7516C138.064 46.1906 99.4 95.2286 96.208 152.393C93.48 152.137 90.736 152.009 88 152.009C39.399 152.009 0 191.408 0 240.009C0 288.61 39.399 328.009 88 328.009H104V352.009C104 356.427 107.582 360.009 112 360.009H128V376.009H112C107.582 376.009 104 379.591 104 384.009V448.009C104 452.427 107.582 456.009 112 456.009H368C372.418 456.009 376 452.427 376 448.009V384.009C376 379.591 372.418 376.009 368 376.009H352V360.009H368C372.418 360.009 376 356.427 376 352.009V328.009C433.438 328.009 480 281.447 480 224.009C480 166.571 433.438 120.009 376 120.009ZM360 392.009V440.009H120V392.009H360ZM144 376.009V360.009H336V376.009H144ZM360 344.009H120V296.009H360V344.009ZM393.993 310.145C388.075 311.383 382.046 312.007 376 312.009V288.009C376 283.591 372.418 280.009 368 280.009H288V208.009H361.472C365.89 220.506 379.603 227.055 392.099 222.636C404.596 218.218 411.145 204.505 406.726 192.009C402.308 179.512 388.595 172.963 376.099 177.382C369.264 179.798 363.888 185.175 361.472 192.009H280C275.582 192.009 272 195.591 272 200.009V280.009H232V128.009H265.472C269.89 140.506 283.603 147.055 296.099 142.636C308.596 138.218 315.145 124.505 310.726 112.009C306.308 99.5116 292.595 92.9626 280.099 97.3816C273.264 99.7976 267.888 105.175 265.472 112.009H224C219.582 112.009 216 115.591 216 120.009V280.009H176V224.009C176 219.591 172.418 216.009 168 216.009H126.528C122.11 203.512 108.397 196.963 95.901 201.382C83.405 205.801 76.855 219.513 81.274 232.009C85.693 244.505 99.405 251.055 111.901 246.636C118.736 244.22 124.112 238.843 126.528 232.009H160V280.009H112C107.582 280.009 104 283.591 104 288.009V312.009H88C48.235 312.009 16 279.773 16 240.009C16 200.244 48.235 168.009 88 168.009C92.869 168.013 97.725 168.503 102.496 169.473C104.868 169.937 107.323 169.318 109.192 167.785C111.054 166.239 112.116 163.933 112.08 161.513C112.08 161.353 112.008 160.169 112 160.009C111.956 93.7696 165.617 40.0366 231.856 39.9926C287.33 39.9556 335.59 77.9666 348.552 131.905C349.56 136.11 353.726 138.753 357.96 137.873C405.532 127.923 452.162 158.421 462.112 205.993C472.062 253.565 441.564 300.195 393.993 310.145ZM376 200.009C376 195.591 379.582 192.009 384 192.009C388.418 192.009 392 195.591 392 200.009C392 204.427 388.418 208.009 384 208.009C379.582 208.009 376 204.427 376 200.009ZM280 120.009C280 115.591 283.582 112.009 288 112.009C292.418 112.009 296 115.591 296 120.009C296 124.427 292.418 128.009 288 128.009C283.582 128.009 280 124.427 280 120.009ZM112 224.009C112 228.427 108.418 232.009 104 232.009C99.582 232.009 96 228.427 96 224.009C96 219.591 99.582 216.009 104 216.009C108.418 216.009 112 219.59 112 224.009Z"
              fill="#242424"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
